export const DEFAULT_MARTINGALES = 1;
export const MAX_MARTINGALES = 10;
export const isValidMartingaleCount = value => Number.isInteger(value) && value >= 0 && value <= MAX_MARTINGALES;
export const martingaleAmount = (amount, level) => Math.round(amount * 100) * 2 ** level / 100;
export const validMartingaleAmounts = (amount, count) => Number.isSafeInteger(Math.round(amount * 100) * 2 ** count);
